export const IFRAME_SANDBOX = 'allow-scripts allow-same-origin';
export const IFRAME_ALLOW_PERMISSIONS =
  'publickey-credentials-create; publickey-credentials-get';
